import gql from 'graphql-tag';
import { ServerError, ServerParseError, useQuery } from '@apollo/client';
import { Me, Me_me } from '../../../admin/state/types';
import { isProduction } from '../../../lib/environment';

const meQuery = gql`
  query Me {
    me {
      user {
        userId
        givenName
        familyName
        userRoles
        actingMember
      }
      member {
        id
        sdxMemberId
        dltNodeName
      }
      memberRoles
      assetTypes
      legalEntity {
        name
      }
    }
  }
`;

interface MeReturnValue {
  loading: boolean;
  me?: Me_me;
  statusCode?: number;
}

type NetworkError = Error | ServerParseError | ServerError | null;

function isServerError(error?: NetworkError): error is ServerError {
  return (error as ServerError)?.statusCode !== undefined;
}

function isServerParseError(error?: NetworkError): error is ServerParseError {
  return (error as ServerParseError)?.statusCode !== undefined;
}

const useMe = (): MeReturnValue => {
  const { data, loading, error } = useQuery<Me>(meQuery, { errorPolicy: isProduction() ? undefined : 'ignore' });
  const networkError = error?.networkError;
  const statusCode = isServerError(networkError) || isServerParseError(networkError) ? networkError.statusCode : undefined;
  return { loading, me: data?.me, statusCode };
};

export default useMe;
